import { observer, useLocalObservable } from "mobx-react"
import { Flex, Table } from "antd"
import { choose } from "choose-matching"

import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { OnRampPaymentsCollection } from "@src/pages/transactionsOnRamp/classes/OnRampPaymentsCollection"
import { transactionsOnRampColumns } from "@src/pages/transactionsOnRamp/constants"
import { OnRampPaymentExpandable } from "@src/pages/transactionsOnRamp/OnRampPaymentExpandable"
import { TransactionsOutEmpty } from "@src/pages/transactionsOut/constants"
import { TableFilters } from "@src/shared/componemts/TableFilter"

export const TransactionsOnRampPage = observer(() => {
  const collection = useLocalObservable(() => new OnRampPaymentsCollection())

  return (
    <Flex gap={16} vertical>
      <TableFilters {...collection.filter.props} />
      {choose(
        [collection.isLoading && collection.isEmpty, <LoadingBlock />],
        [collection.isEmpty, <TransactionsOutEmpty />],
        [
          !collection.isEmpty,
          <Table
            columns={transactionsOnRampColumns}
            dataSource={collection.items}
            expandable={{
              expandedRowRender: (record) => (
                <OnRampPaymentExpandable
                  isLoading={collection.isLoading}
                  payment={record}
                />
              ),
            }}
            loading={collection.isLoading}
            pagination={collection.pagination}
            rowKey="id"
            scroll={{ x: true }}
            style={{ width: "100%" }}
          />,
        ],
      )}
    </Flex>
  )
})
